<template>
  <div class="hideOnMobile mt-3">
    <div class="row">
      <ul class="text-center">
        <li v-for="(data, stage) in responseFormat"
            :key="stage"
            :class="[stages[stage], {cursor: stage <= greatestFilled}]"
            @click="jump(stage)">
          <span v-show="stages[stage] === 'complete'" class="circle" v-html="checkSVG" />
          <span v-show="stages[stage] === 'partial'" class="circle">~</span>
          <span v-show="stages[stage] === ''" class="circle" />
          {{ data.name.split('/')[0] }}
        </li>
      </ul>
    </div>
  </div>
</template>


<style scoped lang="scss">
  @media (max-width: 991px) {
    .hideOnMobile {
      display: none;
    }
  }

  ul {
    margin: 0;
    padding: 0;
    width: 100%;


    li {
      list-style: none;
      display: inline-block;
      position: relative;
      text-align: center;
      vertical-align: top;
      width: 5em;
      margin: 0 1em;

      @media (max-width: 991px) {
        width: 100%;
        margin: 0.5em 0;
      }
    }

    li .circle {
      width: 2em;
      height: 2em;
      line-height: 1.8em;
      border: 1px solid #ddd;
      border-radius: 100%;
      display: block;
      text-align: center;
      margin: 0 auto 10px auto;
      padding-top: 0;
      background-color: #fff;
      position: relative;
      z-index: 2;
      color: white;

      ::v-deep .octicon {
        display: inline;
        fill: white;
      }
    }

    li.partial .circle {
      background-color: #ddd;
      border: 1px solid #ddd;
    }

    li.complete .circle {
      background-color: #66b366;
      border: 1px solid #66b366;
    }

    @media (min-width: 992px) {
      li:after {
        content: "";
        position: absolute;
        width: 80%;
        height: 1px;
        background-color: #ddd;
        top: 1em;
        z-index: 1;
        left: -60%;
      }
    }

    li:first-child:after {
      content: none;
    }
  }
</style>

<script>
  import octicons from "@primer/octicons"

  export default {
    name: 'EvaluationSubcomponentsProgressBar',
    props: {
      evaluationData: {type: Object, required: true},
      responseFormat: {type: Array, required: true},
      jumpToStage: {type: Function, required: true},
    },
    data() {
      return {
        requiredKeys: {},
        greatestFilled: 0,
        stages: {},

        checkSVG: octicons["check"].toSVG(),

        showList: false,
      }
    },
    watch: {
      evaluationData() {
        this.setStages()
      }
    },
    created() {
      for (let i = 0; i < this.responseFormat.length; i++) {
        this.requiredKeys[i] = Object.keys(this.responseFormat[i].data)
      }
      this.setStages()
    },
    methods: {
      jump(stage) {
        if (stage <= this.greatestFilled) {
          this.jumpToStage(stage)
        }
      },
      setStages() {
        for (let stage = 0; stage < this.responseFormat.length; stage++) {
          this.stages[stage] = this.getStageClass(stage)
          if (this.stages[stage] !== '') {
            this.greatestFilled = stage
          }
        }
        this.$forceUpdate()
      },
      getStageClass(stageId) {
        let theseKeys = this.requiredKeys[stageId],
          keyCount = theseKeys.filter(key => this.evaluationData[key] !== undefined).length

        switch (keyCount) {
          case theseKeys.length:
            return 'complete'
          case 0:
            return ''
          default:
            return 'partial'
        }
      }
    }
  }
</script>
